import { render } from "./TeamCabinet.vue?vue&type=template&id=4abff06c"
import script from "./TeamCabinet.vue?vue&type=script&lang=js"
export * from "./TeamCabinet.vue?vue&type=script&lang=js"

import "./TeamCabinet.vue?vue&type=style&index=0&id=4abff06c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__